import { api } from '../../plugins/api';

const getDefaultState = () => {
  return {
    existe: false
  }
}

const state = getDefaultState()

const getters = {
    GET_CONTACTEXISTE: (state) => { return state.existe }
}

const mutations = {
    SET_CONTACTEXISTE(state, existe){
        state.existe = existe
    },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  async existe ({ commit }, pRenseignementsGenerauxDTO) {
    const response = await api.post('contacts/existe', pRenseignementsGenerauxDTO)
    commit("SET_CONTACTEXISTE", response.data)
  },
  resetModuleState ({ commit }) {
    commit('resetState')
  },
}

export default ({
    namespaced: true,
    state: state,
    mutations: mutations,
    getters: getters,
    actions: actions
})